module.exports = __webpack_public_path__ + "img/rb-ur3.bdabfa25.jpg";